import React from 'react';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
`;

const StyledButton = styled.button<{ isActive: boolean }>`
  ${({ theme, isActive }) => `
   all: unset;
   width: 15px;
   height: 2px;
   background: ${isActive ? theme.components.carousel.indicator.backgroundColor.active : theme.components.carousel.indicator.backgroundColor.inactive};
   border-radius: 1px;
   margin-right: 6px;
   &:last-child {
     margin-right: 0;
   }
`}
`;

const CustomPagination = ({ activeIndex, slides }: { activeIndex: number; slides: number }) => (
  <PaginationContainer>
    {Array.from(Array(slides).keys()).map((slide: any, index: number) => (
      <StyledButton key={slide} isActive={activeIndex === index} />
    ))}
  </PaginationContainer>
);

export default CustomPagination;
